const projectComplete = (param: any) => {
  return `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional //EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
    <html
      xmlns="http://www.w3.org/1999/xhtml"
      xmlns:o="urn:schemas-microsoft-com:office:office"
      xmlns:v="urn:schemas-microsoft-com:vml"
    >
      <head>
        <!--[if gte mso 9
          ]><xml
            ><o:OfficeDocumentSettings
              ><o:AllowPNG /><o:PixelsPerInch
                >96</o:PixelsPerInch
              ></o:OfficeDocumentSettings
            ></xml
          ><!
        [endif]-->
        <meta content="text/html; charset=utf-8" http-equiv="Content-Type" />
        <meta content="width=device-width" name="viewport" />
        <!--[if !mso]><!-->
        <meta content="IE=edge" http-equiv="X-UA-Compatible" />
        <!--<![endif]-->
        <title></title>
        <!--[if !mso]><!-->
        <link
          href="https://fonts.googleapis.com/css?family=Kanit"
          rel="stylesheet"
          type="text/css"
        />
        <!--<![endif]-->
        <style type="text/css">
          body {
            margin: 0;
            padding: 0;
            font-family: "Kanit";
          }
          p {
            font-family: "Kanit";
          }
    
          table,
          td,
          tr {
            vertical-align: top;
            border-collapse: collapse;
          }
    
          * {
            line-height: inherit;
          }
    
          a[x-apple-data-detectors="true"] {
            color: inherit !important;
            text-decoration: none !important;
          }
        </style>
        <style id="media-query" type="text/css">
          @media (max-width: 620px) {
            .block-grid,
            .col {
              min-width: 320px !important;
              max-width: 100% !important;
              display: block !important;
            }
    
            .block-grid {
              width: 100% !important;
            }
    
            .col {
              width: 100% !important;
            }
    
            .col > div {
              margin: 0 auto;
            }
    
            img.fullwidth,
            img.fullwidthOnMobile {
              max-width: 100% !important;
            }
    
            .no-stack .col {
              min-width: 0 !important;
              display: table-cell !important;
            }
    
            .no-stack.two-up .col {
              width: 50% !important;
            }
    
            .no-stack .col.num4 {
              width: 33% !important;
            }
    
            .no-stack .col.num8 {
              width: 66% !important;
            }
    
            .no-stack .col.num4 {
              width: 33% !important;
            }
    
            .no-stack .col.num3 {
              width: 25% !important;
            }
    
            .no-stack .col.num6 {
              width: 50% !important;
            }
    
            .no-stack .col.num9 {
              width: 75% !important;
            }
    
            .video-block {
              max-width: none !important;
            }
    
            .mobile_hide {
              min-height: 0px;
              max-height: 0px;
              max-width: 0px;
              display: none;
              overflow: hidden;
              font-size: 0px;
            }
    
            .desktop_hide {
              display: block !important;
              max-height: none !important;
            }
          }
        </style>
      </head>
      <body
        class="clean-body"
        style="
          margin: 0;
          padding: 0;
          -webkit-text-size-adjust: 100%;
          background-color: #ededed;
        "
      >
        <!--[if IE]><div class="ie-browser"><![endif]-->
        <table
          bgcolor="#ededed"
          cellpadding="0"
          cellspacing="0"
          class="nl-container"
          role="presentation"
          style="
            table-layout: fixed;
            vertical-align: top;
            min-width: 320px;
            margin: 0 auto;
            border-spacing: 0;
            border-collapse: collapse;
            mso-table-lspace: 0pt;
            mso-table-rspace: 0pt;
            background-color: #ededed;
            width: 100%;
          "
          valign="top"
          width="100%"
        >
          <tbody>
            <tr style="vertical-align: top;" valign="top">
              <td style="word-break: break-word; vertical-align: top;" valign="top">
                <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td align="center" style="background-color:#ededed"><![endif]-->
                <div style="background-color: transparent;">
                  <div
                    class="block-grid"
                    style="
                      margin: 0 auto;
                      min-width: 320px;
                      max-width: 600px;
                      overflow-wrap: break-word;
                      word-wrap: break-word;
                      word-break: break-word;
                      background-color: transparent;
                    "
                  >
                    <div
                      style="
                        border-collapse: collapse;
                        display: table;
                        width: 100%;
                        background-color: transparent;
                      "
                    >
                      <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color:transparent;"><tr><td align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px"><tr class="layout-full-width" style="background-color:transparent"><![endif]-->
                      <!--[if (mso)|(IE)]><td align="center" width="600" style="background-color:transparent;width:600px; border-top: 0px solid transparent; border-left: 0px solid transparent; border-bottom: 0px solid transparent; border-right: 0px solid transparent;" valign="top"><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 0px; padding-left: 0px; padding-top:5px; padding-bottom:5px;"><![endif]-->
                      <div
                        class="col num12"
                        style="
                          min-width: 320px;
                          max-width: 600px;
                          display: table-cell;
                          vertical-align: top;
                          width: 600px;
                        "
                      >
                        <div style="width: 100% !important;">
                          <!--[if (!mso)&(!IE)]><!-->
                          <div
                            style="
                              border-top: 0px solid transparent;
                              border-left: 0px solid transparent;
                              border-bottom: 0px solid transparent;
                              border-right: 0px solid transparent;
                              padding-top: 5px;
                              padding-bottom: 5px;
                              padding-right: 0px;
                              padding-left: 0px;
                            "
                          >
                            <!--<![endif]-->
                            <div
                              align="center"
                              class="img-container center fixedwidth"
                              style="padding-right: 0px; padding-left: 0px;"
                            >
                              <!--[if mso]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr style="line-height:0px"><td style="padding-right: 0px;padding-left: 0px;" align="center"><![endif]-->
                              <div style="font-size: 1px; line-height: 25px;"></div>
                              <img
                                align="center"
                                alt="Your Logo"
                                border="0"
                                class="center fixedwidth"
                                src="https://upload.i-bitz.co.th/files/2020/08/26/38bb755dbe754e6552f4ef99.png"
                                style="
                                  text-decoration: none;
                                  -ms-interpolation-mode: bicubic;
                                  height: auto;
                                  border: 0;
                                  width: 100%;
                                  max-width: 210px;
                                  display: block;
                                "
                                title="Your Logo"
                                width="210"
                              />
                              <div style="font-size: 1px; line-height: 25px;"></div>
                              <!--[if mso]></td></tr></table><![endif]-->
                            </div>
                            <!--[if (!mso)&(!IE)]><!-->
                          </div>
                          <!--<![endif]-->
                        </div>
                      </div>
                      <!--[if (mso)|(IE)]></td></tr></table><![endif]-->
                      <!--[if (mso)|(IE)]></td></tr></table></td></tr></table><![endif]-->
                    </div>
                  </div>
                </div>
                <div style="background-color: transparent;">
                  <div
                    class="block-grid"
                    style="
                      margin: 0 auto;
                      min-width: 320px;
                      max-width: 600px;
                      overflow-wrap: break-word;
                      word-wrap: break-word;
                      word-break: break-word;
                      background-color: #ffffff;
                    "
                  >
                    <div
                      style="
                        border-collapse: collapse;
                        display: table;
                        width: 100%;
                        background-color: #ffffff;
                      "
                    >
                      <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color:transparent;"><tr><td align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px"><tr class="layout-full-width" style="background-color:#ffffff"><![endif]-->
                      <!--[if (mso)|(IE)]><td align="center" width="600" style="background-color:#ffffff;width:600px; border-top: 0px solid transparent; border-left: 0px solid transparent; border-bottom: 0px solid transparent; border-right: 0px solid transparent;" valign="top"><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 0px; padding-left: 0px; padding-top:5px; padding-bottom:5px;"><![endif]-->
                      <div
                        class="col num12"
                        style="
                          min-width: 320px;
                          max-width: 600px;
                          display: table-cell;
                          vertical-align: top;
                          width: 600px;
                        "
                      >
                        <div style="width: 100% !important;">
                          <!--[if (!mso)&(!IE)]><!-->
                          <div
                            style="
                              border-top: 0px solid transparent;
                              border-left: 0px solid transparent;
                              border-bottom: 0px solid transparent;
                              border-right: 0px solid transparent;
                              padding-top: 5px;
                              padding-bottom: 5px;
                              padding-right: 0px;
                              padding-left: 0px;
                            "
                          >
                            <!--<![endif]-->
                            <table
                              border="0"
                              cellpadding="0"
                              cellspacing="0"
                              class="divider"
                              role="presentation"
                              style="
                                table-layout: fixed;
                                vertical-align: top;
                                border-spacing: 0;
                                border-collapse: collapse;
                                mso-table-lspace: 0pt;
                                mso-table-rspace: 0pt;
                                min-width: 100%;
                                -ms-text-size-adjust: 100%;
                                -webkit-text-size-adjust: 100%;
                              "
                              valign="top"
                              width="100%"
                            >
                              <tbody>
                                <tr style="vertical-align: top;" valign="top">
                                  <td
                                    class="divider_inner"
                                    style="
                                      word-break: break-word;
                                      vertical-align: top;
                                      min-width: 100%;
                                      -ms-text-size-adjust: 100%;
                                      -webkit-text-size-adjust: 100%;
                                      padding-top: 0px;
                                      padding-right: 0px;
                                      padding-bottom: 0px;
                                      padding-left: 0px;
                                    "
                                    valign="top"
                                  >
                                    <table
                                      align="center"
                                      border="0"
                                      cellpadding="0"
                                      cellspacing="0"
                                      class="divider_content"
                                      height="30"
                                      role="presentation"
                                      style="
                                        table-layout: fixed;
                                        vertical-align: top;
                                        border-spacing: 0;
                                        border-collapse: collapse;
                                        mso-table-lspace: 0pt;
                                        mso-table-rspace: 0pt;
                                        border-top: 0px solid transparent;
                                        height: 30px;
                                        width: 100%;
                                      "
                                      valign="top"
                                      width="100%"
                                    >
                                      <tbody>
                                        <tr
                                          style="vertical-align: top;"
                                          valign="top"
                                        >
                                          <td
                                            height="30"
                                            style="
                                              word-break: break-word;
                                              vertical-align: top;
                                              -ms-text-size-adjust: 100%;
                                              -webkit-text-size-adjust: 100%;
                                            "
                                            valign="top"
                                          >
                                            <span></span>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <!--[if mso]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 10px; padding-left: 10px; padding-top: 10px; padding-bottom: 10px; font-family: Tahoma, sans-serif"><![endif]-->
                            <div
                              style="
                                color: #555555;
    
                                line-height: 1.2;
                                padding-top: 10px;
                                padding-right: 10px;
                                padding-bottom: 10px;
                                padding-left: 10px;
                              "
                            >
                              <div
                                style="
                                  line-height: 1.2;
                                  font-size: 12px;
                                  color: #555555;
                                  font-family: Montserrat, Trebuchet MS,
                                    Lucida Grande, Lucida Sans Unicode, Lucida Sans,
                                    Tahoma, sans-serif;
                                  mso-line-height-alt: 14px;
                                "
                              >
                                <p
                                  style="
                                    font-size: 14px;
                                    line-height: 1.2;
                                    word-break: break-word;
                                    mso-line-height-alt: 17px;
                                    margin: 0;
                                  "
                                >
                                  เรียน หน.กจ. และ หน.บร.
                                </p>
                              </div>
                            </div>
                            <!--[if mso]></td></tr></table><![endif]-->
                            <!--[if (!mso)&(!IE)]><!-->
                          </div>
                          <!--<![endif]-->
                        </div>
                      </div>
                      <!--[if (mso)|(IE)]></td></tr></table><![endif]-->
                      <!--[if (mso)|(IE)]></td></tr></table></td></tr></table><![endif]-->
                    </div>
                  </div>
                </div>
                <div style="background-color: transparent;">
                  <div
                    class="block-grid"
                    style="
                      margin: 0 auto;
                      min-width: 320px;
                      max-width: 600px;
                      overflow-wrap: break-word;
                      word-wrap: break-word;
                      word-break: break-word;
                      background-color: #ffffff;
                    "
                  >
                    <div
                      style="
                        border-collapse: collapse;
                        display: table;
                        width: 100%;
                        background-color: #ffffff;
                      "
                    >
                      <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color:transparent;"><tr><td align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px"><tr class="layout-full-width" style="background-color:#ffffff"><![endif]-->
                      <!--[if (mso)|(IE)]><td align="center" width="600" style="background-color:#ffffff;width:600px; border-top: 0px solid transparent; border-left: 0px solid transparent; border-bottom: 0px solid transparent; border-right: 0px solid transparent;" valign="top"><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 0px; padding-left: 0px; padding-top:5px; padding-bottom:5px;"><![endif]-->
                      <div
                        class="col num12"
                        style="
                          min-width: 320px;
                          max-width: 600px;
                          display: table-cell;
                          vertical-align: top;
                          width: 600px;
                        "
                      >
                        <div style="width: 100% !important;">
                          <!--[if (!mso)&(!IE)]><!-->
                          <div
                            style="
                              border-top: 0px solid transparent;
                              border-left: 0px solid transparent;
                              border-bottom: 0px solid transparent;
                              border-right: 0px solid transparent;
                              padding-top: 5px;
                              padding-bottom: 5px;
                              padding-right: 0px;
                              padding-left: 0px;
                            "
                          >
                            <!--<![endif]-->
                            <!--[if mso]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 15px; padding-left: 15px; padding-top: 10px; padding-bottom: 10px; font-family: Tahoma, sans-serif"><![endif]-->
                            <div
                              style="
                                color: #555555;
    
                                line-height: 1.2;
                                padding-top: 10px;
                                padding-right: 15px;
                                padding-bottom: 10px;
                                padding-left: 15px;
                              "
                            >
                              <div
                                style="
                                  line-height: 1.2;
                                  font-size: 12px;
                                  color: #555555;
                                  font-family: Montserrat, Trebuchet MS,
                                    Lucida Grande, Lucida Sans Unicode, Lucida Sans,
                                    Tahoma, sans-serif;
                                  mso-line-height-alt: 14px;
                                "
                              >
                                <p
                                  style="
                                    font-size: 14px;
                                    line-height: 1.2;
                                    word-break: break-word;
                                    mso-line-height-alt: 17px;
                                    margin: 0;
                                  "
                                >
                                  งานออกแบบเลขที่ ${param.work_order_no} ชื่อลูกค้า ${param.customer_name}
                                  รายละเอียด ${param.detail} ที่อยู๋ ${param.customer_address}
                                </p>
                              </div>
                            </div>
                            <!--[if mso]></td></tr></table><![endif]-->
                            <!--[if mso]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 15px; padding-left: 15px; padding-top: 10px; padding-bottom: 10px; font-family: Tahoma, sans-serif"><![endif]-->
                            <div
                              style="
                                color: #555555;
    
                                line-height: 1.2;
                                padding-top: 10px;
                                padding-right: 15px;
                                padding-bottom: 10px;
                                padding-left: 15px;
                              "
                            >
                              <div
                                style="
                                  line-height: 1.2;
                                  font-size: 12px;
                                  color: #555555;
                                  font-family: Montserrat, Trebuchet MS,
                                    Lucida Grande, Lucida Sans Unicode, Lucida Sans,
                                    Tahoma, sans-serif;
                                  mso-line-height-alt: 14px;
                                "
                              >
                                <p
                                  style="
                                    font-size: 14px;
                                    line-height: 1.2;
                                    word-break: break-word;
                                    mso-line-height-alt: 17px;
                                    margin: 0;
                                  "
                                >
                                  ดำเนินการออกแบบเรียบร้อยแล้ว
                                </p>
                              </div>
                            </div>
                            <!--[if mso]></td></tr></table><![endif]-->
                            <!--[if (!mso)&(!IE)]><!-->
                          </div>
                          <!--<![endif]-->
                        </div>
                      </div>
                      <!--[if (mso)|(IE)]></td></tr></table><![endif]-->
                      <!--[if (mso)|(IE)]></td></tr></table></td></tr></table><![endif]-->
                    </div>
                  </div>
                </div>
                <div style="background-color: transparent;">
                  <div
                    class="block-grid"
                    style="
                      margin: 0 auto;
                      min-width: 320px;
                      max-width: 600px;
                      overflow-wrap: break-word;
                      word-wrap: break-word;
                      word-break: break-word;
                      background-color: #ffffff;
                    "
                  >
                    <div
                      style="
                        border-collapse: collapse;
                        display: table;
                        width: 100%;
                        background-color: #ffffff;
                      "
                    >
                      <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color:transparent;"><tr><td align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px"><tr class="layout-full-width" style="background-color:#ffffff"><![endif]-->
                      <!--[if (mso)|(IE)]><td align="center" width="600" style="background-color:#ffffff;width:600px; border-top: 0px solid transparent; border-left: 0px solid transparent; border-bottom: 0px solid transparent; border-right: 0px solid transparent;" valign="top"><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 0px; padding-left: 0px; padding-top:5px; padding-bottom:5px;"><![endif]-->
                      <div
                        class="col num12"
                        style="
                          min-width: 320px;
                          max-width: 600px;
                          display: table-cell;
                          vertical-align: top;
                          width: 600px;
                        "
                      >
                        <div style="width: 100% !important;">
                          <!--[if (!mso)&(!IE)]><!-->
                          <div
                            style="
                              border-top: 0px solid transparent;
                              border-left: 0px solid transparent;
                              border-bottom: 0px solid transparent;
                              border-right: 0px solid transparent;
                              padding-top: 5px;
                              padding-bottom: 5px;
                              padding-right: 0px;
                              padding-left: 0px;
                            "
                          >
                            <!--<![endif]-->
                            <!--[if mso]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 10px; padding-left: 10px; padding-top: 10px; padding-bottom: 10px; font-family: Tahoma, sans-serif"><![endif]-->
                            <!--[if mso]></td></tr></table><![endif]-->
                            <!--[if (!mso)&(!IE)]><!-->
                          </div>
                          <!--<![endif]-->
                        </div>
                      </div>
                      <!--[if (mso)|(IE)]></td></tr></table><![endif]-->
                      <!--[if (mso)|(IE)]></td></tr></table></td></tr></table><![endif]-->
                    </div>
                  </div>
                </div>
                <div style="background-color: transparent;">
                  <div
                    class="block-grid two-up"
                    style="
                      margin: 0 auto;
                      min-width: 320px;
                      max-width: 600px;
                      overflow-wrap: break-word;
                      word-wrap: break-word;
                      word-break: break-word;
                      background-color: #ffffff;
                    "
                  >
                    <div
                      style="
                        border-collapse: collapse;
                        display: table;
                        width: 100%;
                        background-color: #ffffff;
                      "
                    >
                      <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color:transparent;"><tr><td align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px"><tr class="layout-full-width" style="background-color:#ffffff"><![endif]-->
                      <!--[if (mso)|(IE)]><td align="center" width="300" style="background-color:#ffffff;width:300px; border-top: 0px solid transparent; border-left: 0px solid transparent; border-bottom: 0px solid transparent; border-right: 0px solid transparent;" valign="top"><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 0px; padding-left: 0px; padding-top:5px; padding-bottom:5px;"><![endif]-->
                      <div
                        class="col num6"
                        style="
                          max-width: 320px;
                          min-width: 300px;
                          display: table-cell;
                          vertical-align: top;
                          width: 300px;
                        "
                      >
                        <div style="width: 100% !important;">
                          <!--[if (!mso)&(!IE)]><!-->
                          <div
                            style="
                              border-top: 0px solid transparent;
                              border-left: 0px solid transparent;
                              border-bottom: 0px solid transparent;
                              border-right: 0px solid transparent;
                              padding-top: 5px;
                              padding-bottom: 5px;
                              padding-right: 0px;
                              padding-left: 0px;
                            "
                          >
                            <!--<![endif]-->
                            <!--[if mso]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 10px; padding-left: 10px; padding-top: 10px; padding-bottom: 10px; font-family: Tahoma, sans-serif"><![endif]-->
                            <!--[if mso]></td></tr></table><![endif]-->
                            <!--[if (!mso)&(!IE)]><!-->
                          </div>
                          <!--<![endif]-->
                        </div>
                      </div>
                      <!--[if (mso)|(IE)]></td></tr></table><![endif]-->
                      <!--[if (mso)|(IE)]></td><td align="center" width="300" style="background-color:#ffffff;width:300px; border-top: 0px solid transparent; border-left: 0px solid transparent; border-bottom: 0px solid transparent; border-right: 0px solid transparent;" valign="top"><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 0px; padding-left: 0px; padding-top:5px; padding-bottom:5px;"><![endif]-->
                      <div
                        class="col num6"
                        style="
                          max-width: 320px;
                          min-width: 300px;
                          display: table-cell;
                          vertical-align: top;
                          width: 300px;
                        "
                      >
                        <div style="width: 100% !important;">
                          <!--[if (!mso)&(!IE)]><!-->
                          <div
                            style="
                              border-top: 0px solid transparent;
                              border-left: 0px solid transparent;
                              border-bottom: 0px solid transparent;
                              border-right: 0px solid transparent;
                              padding-top: 5px;
                              padding-bottom: 5px;
                              padding-right: 0px;
                              padding-left: 0px;
                            "
                          >
                            <!--<![endif]-->
                            <!--[if mso]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 10px; padding-left: 10px; padding-top: 10px; padding-bottom: 10px; font-family: Tahoma, sans-serif"><![endif]-->
                            <div
                              style="
                                color: #555555;
    
                                line-height: 1.2;
                                padding-top: 10px;
                                padding-right: 10px;
                                padding-bottom: 10px;
                                padding-left: 10px;
                              "
                            >
                              <div
                                style="
                                  line-height: 1.2;
                                  font-size: 12px;
                                  color: #555555;
                                  font-family: Montserrat, Trebuchet MS,
                                    Lucida Grande, Lucida Sans Unicode, Lucida Sans,
                                    Tahoma, sans-serif;
                                  mso-line-height-alt: 14px;
                                "
                              >
                                <p
                                  style="
                                    text-align: center;
                                    line-height: 1.2;
                                    word-break: break-word;
                                    mso-line-height-alt: 14px;
                                    margin: 0;
                                  "
                                >
                                  ${param.first_name}  ${param.lastname}
                                </p>
                                <p
                                  style="
                                    text-align: center;
                                    line-height: 1.2;
                                    word-break: break-word;
                                    mso-line-height-alt: 14px;
                                    margin: 0;
                                  "
                                >
                                  หน.อป.
                                </p>
                                <p
                                  style="
                                    text-align: center;
                                    line-height: 1.2;
                                    word-break: break-word;
                                    mso-line-height-alt: 14px;
                                    margin: 0;
                                  "
                                >
                                  ${param.department_name}
                                </p>
                              </div>
                            </div>
                            <!--[if mso]></td></tr></table><![endif]-->
                            <!--[if (!mso)&(!IE)]><!-->
                          </div>
                          <!--<![endif]-->
                        </div>
                      </div>
                      <!--[if (mso)|(IE)]></td></tr></table><![endif]-->
                      <!--[if (mso)|(IE)]></td></tr></table></td></tr></table><![endif]-->
                    </div>
                  </div>
                </div>
                <div style="background-color: transparent;">
                  <div
                    class="block-grid"
                    style="
                      margin: 0 auto;
                      min-width: 320px;
                      max-width: 600px;
                      overflow-wrap: break-word;
                      word-wrap: break-word;
                      word-break: break-word;
                      background-color: #ffffff;
                    "
                  >
                    <div
                      style="
                        border-collapse: collapse;
                        display: table;
                        width: 100%;
                        background-color: #ffffff;
                      "
                    >
                      <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color:transparent;"><tr><td align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px"><tr class="layout-full-width" style="background-color:#ffffff"><![endif]-->
                      <!--[if (mso)|(IE)]><td align="center" width="600" style="background-color:#ffffff;width:600px; border-top: 0px solid transparent; border-left: 0px solid transparent; border-bottom: 0px solid transparent; border-right: 0px solid transparent;" valign="top"><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 0px; padding-left: 0px; padding-top:5px; padding-bottom:5px;"><![endif]-->
                      <div
                        class="col num12"
                        style="
                          min-width: 320px;
                          max-width: 600px;
                          display: table-cell;
                          vertical-align: top;
                          width: 600px;
                        "
                      >
                        <div style="width: 100% !important;">
                          <!--[if (!mso)&(!IE)]><!-->
                          <div
                            style="
                              border-top: 0px solid transparent;
                              border-left: 0px solid transparent;
                              border-bottom: 0px solid transparent;
                              border-right: 0px solid transparent;
                              padding-top: 5px;
                              padding-bottom: 5px;
                              padding-right: 0px;
                              padding-left: 0px;
                            "
                          >
                            <!--<![endif]-->
                            <table
                              border="0"
                              cellpadding="0"
                              cellspacing="0"
                              class="divider"
                              role="presentation"
                              style="
                                table-layout: fixed;
                                vertical-align: top;
                                border-spacing: 0;
                                border-collapse: collapse;
                                mso-table-lspace: 0pt;
                                mso-table-rspace: 0pt;
                                min-width: 100%;
                                -ms-text-size-adjust: 100%;
                                -webkit-text-size-adjust: 100%;
                              "
                              valign="top"
                              width="100%"
                            >
                              <tbody>
                                <tr style="vertical-align: top;" valign="top">
                                  <td
                                    class="divider_inner"
                                    style="
                                      word-break: break-word;
                                      vertical-align: top;
                                      min-width: 100%;
                                      -ms-text-size-adjust: 100%;
                                      -webkit-text-size-adjust: 100%;
                                      padding-top: 0px;
                                      padding-right: 0px;
                                      padding-bottom: 0px;
                                      padding-left: 0px;
                                    "
                                    valign="top"
                                  >
                                    <table
                                      align="center"
                                      border="0"
                                      cellpadding="0"
                                      cellspacing="0"
                                      class="divider_content"
                                      height="30"
                                      role="presentation"
                                      style="
                                        table-layout: fixed;
                                        vertical-align: top;
                                        border-spacing: 0;
                                        border-collapse: collapse;
                                        mso-table-lspace: 0pt;
                                        mso-table-rspace: 0pt;
                                        border-top: 0px solid transparent;
                                        height: 30px;
                                        width: 100%;
                                      "
                                      valign="top"
                                      width="100%"
                                    >
                                      <tbody>
                                        <tr
                                          style="vertical-align: top;"
                                          valign="top"
                                        >
                                          <td
                                            height="30"
                                            style="
                                              word-break: break-word;
                                              vertical-align: top;
                                              -ms-text-size-adjust: 100%;
                                              -webkit-text-size-adjust: 100%;
                                            "
                                            valign="top"
                                          >
                                            <span></span>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <!--[if (!mso)&(!IE)]><!-->
                          </div>
                          <!--<![endif]-->
                        </div>
                      </div>
                      <!--[if (mso)|(IE)]></td></tr></table><![endif]-->
                      <!--[if (mso)|(IE)]></td></tr></table></td></tr></table><![endif]-->
                    </div>
                  </div>
                </div>
                <div style="background-color: transparent;">
                  <div
                    class="block-grid"
                    style="
                      margin: 0 auto;
                      min-width: 320px;
                      max-width: 600px;
                      overflow-wrap: break-word;
                      word-wrap: break-word;
                      word-break: break-word;
                      background-color: transparent;
                    "
                  >
                    <div
                      style="
                        border-collapse: collapse;
                        display: table;
                        width: 100%;
                        background-color: transparent;
                      "
                    >
                      <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color:transparent;"><tr><td align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px"><tr class="layout-full-width" style="background-color:transparent"><![endif]-->
                      <!--[if (mso)|(IE)]><td align="center" width="600" style="background-color:transparent;width:600px; border-top: 0px solid transparent; border-left: 0px solid transparent; border-bottom: 0px solid transparent; border-right: 0px solid transparent;" valign="top"><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 0px; padding-left: 0px; padding-top:5px; padding-bottom:5px;"><![endif]-->
                      <div
                        class="col num12"
                        style="
                          min-width: 320px;
                          max-width: 600px;
                          display: table-cell;
                          vertical-align: top;
                          width: 600px;
                        "
                      >
                        <div style="width: 100% !important;">
                          <!--[if (!mso)&(!IE)]><!-->
                          <div
                            style="
                              border-top: 0px solid transparent;
                              border-left: 0px solid transparent;
                              border-bottom: 0px solid transparent;
                              border-right: 0px solid transparent;
                              padding-top: 5px;
                              padding-bottom: 5px;
                              padding-right: 0px;
                              padding-left: 0px;
                            "
                          >
                            <!--<![endif]-->
                            <table
                              border="0"
                              cellpadding="0"
                              cellspacing="0"
                              class="divider"
                              role="presentation"
                              style="
                                table-layout: fixed;
                                vertical-align: top;
                                border-spacing: 0;
                                border-collapse: collapse;
                                mso-table-lspace: 0pt;
                                mso-table-rspace: 0pt;
                                min-width: 100%;
                                -ms-text-size-adjust: 100%;
                                -webkit-text-size-adjust: 100%;
                              "
                              valign="top"
                              width="100%"
                            >
                              <tbody>
                                <tr style="vertical-align: top;" valign="top">
                                  <td
                                    class="divider_inner"
                                    style="
                                      word-break: break-word;
                                      vertical-align: top;
                                      min-width: 100%;
                                      -ms-text-size-adjust: 100%;
                                      -webkit-text-size-adjust: 100%;
                                      padding-top: 0px;
                                      padding-right: 0px;
                                      padding-bottom: 0px;
                                      padding-left: 0px;
                                    "
                                    valign="top"
                                  >
                                    <table
                                      align="center"
                                      border="0"
                                      cellpadding="0"
                                      cellspacing="0"
                                      class="divider_content"
                                      height="20"
                                      role="presentation"
                                      style="
                                        table-layout: fixed;
                                        vertical-align: top;
                                        border-spacing: 0;
                                        border-collapse: collapse;
                                        mso-table-lspace: 0pt;
                                        mso-table-rspace: 0pt;
                                        border-top: 0px solid transparent;
                                        height: 20px;
                                        width: 100%;
                                      "
                                      valign="top"
                                      width="100%"
                                    >
                                      <tbody>
                                        <tr
                                          style="vertical-align: top;"
                                          valign="top"
                                        >
                                          <td
                                            height="20"
                                            style="
                                              word-break: break-word;
                                              vertical-align: top;
                                              -ms-text-size-adjust: 100%;
                                              -webkit-text-size-adjust: 100%;
                                            "
                                            valign="top"
                                          >
                                            <span></span>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <!--[if mso]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 10px; padding-left: 10px; padding-top: 10px; padding-bottom: 10px; font-family: Tahoma, sans-serif"><![endif]-->
                            <div
                              style="
                                color: #7b7b7b;
    
                                line-height: 1.2;
                                padding-top: 10px;
                                padding-right: 10px;
                                padding-bottom: 10px;
                                padding-left: 10px;
                              "
                            >
                              <div
                                style="
                                  line-height: 1.2;
                                  font-size: 12px;
                                  color: #7b7b7b;
                                  font-family: Montserrat, Trebuchet MS,
                                    Lucida Grande, Lucida Sans Unicode, Lucida Sans,
                                    Tahoma, sans-serif;
                                  mso-line-height-alt: 14px;
                                "
                              >
                                <p
                                  style="
                                    font-size: 12px;
                                    line-height: 1.2;
                                    word-break: break-word;
                                    text-align: center;
                                    mso-line-height-alt: 14px;
                                    margin: 0;
                                  "
                                >
                                  <span style="font-size: 12px;"
                                    >© 2020 Metropolitan Electricity Authority</span
                                  >
                                </p>
                              </div>
                            </div>
                            <!--[if mso]></td></tr></table><![endif]-->
                            <table
                              border="0"
                              cellpadding="0"
                              cellspacing="0"
                              class="divider"
                              role="presentation"
                              style="
                                table-layout: fixed;
                                vertical-align: top;
                                border-spacing: 0;
                                border-collapse: collapse;
                                mso-table-lspace: 0pt;
                                mso-table-rspace: 0pt;
                                min-width: 100%;
                                -ms-text-size-adjust: 100%;
                                -webkit-text-size-adjust: 100%;
                              "
                              valign="top"
                              width="100%"
                            >
                              <tbody>
                                <tr style="vertical-align: top;" valign="top">
                                  <td
                                    class="divider_inner"
                                    style="
                                      word-break: break-word;
                                      vertical-align: top;
                                      min-width: 100%;
                                      -ms-text-size-adjust: 100%;
                                      -webkit-text-size-adjust: 100%;
                                      padding-top: 0px;
                                      padding-right: 0px;
                                      padding-bottom: 0px;
                                      padding-left: 0px;
                                    "
                                    valign="top"
                                  >
                                    <table
                                      align="center"
                                      border="0"
                                      cellpadding="0"
                                      cellspacing="0"
                                      class="divider_content"
                                      height="20"
                                      role="presentation"
                                      style="
                                        table-layout: fixed;
                                        vertical-align: top;
                                        border-spacing: 0;
                                        border-collapse: collapse;
                                        mso-table-lspace: 0pt;
                                        mso-table-rspace: 0pt;
                                        border-top: 0px solid transparent;
                                        height: 20px;
                                        width: 100%;
                                      "
                                      valign="top"
                                      width="100%"
                                    >
                                      <tbody>
                                        <tr
                                          style="vertical-align: top;"
                                          valign="top"
                                        >
                                          <td
                                            height="20"
                                            style="
                                              word-break: break-word;
                                              vertical-align: top;
                                              -ms-text-size-adjust: 100%;
                                              -webkit-text-size-adjust: 100%;
                                            "
                                            valign="top"
                                          >
                                            <span></span>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <!--[if (!mso)&(!IE)]><!-->
                          </div>
                          <!--<![endif]-->
                        </div>
                      </div>
                      <!--[if (mso)|(IE)]></td></tr></table><![endif]-->
                      <!--[if (mso)|(IE)]></td></tr></table></td></tr></table><![endif]-->
                    </div>
                  </div>
                </div>
                <!--[if (mso)|(IE)]></td></tr></table><![endif]-->
              </td>
            </tr>
          </tbody>
        </table>
        <!--[if (IE)]></div><![endif]-->
      </body>
    </html>
    `;
};

export default projectComplete;
